export const MAX_OTP_RESEND_ATTEMPTS = 3;

export const getOtpResendAttemptMessage = (
  resendCount,
  maxAttempts = MAX_OTP_RESEND_ATTEMPTS
) => {
  if (resendCount <= 0) return "";

  const attemptsLeft = Math.max(maxAttempts - resendCount, 0);

  if (attemptsLeft === 0) {
    return "All OTP resend attempts have been used. Please try again later.";
  }

  return `OTP resent successfully. You have ${attemptsLeft} resend ${
    attemptsLeft === 1 ? "attempt" : "attempts"
  } left.`;
};
